<div class="grid grid-cols-4 gap-3 m-3" *ngIf="safety$ | async as safety">
  <div>
    <div>
      <div class="font-bold text-3xl mb-2">Driver Score</div>
      <div class="card-with-shadow bg-white text-center p-2 py-5 text-gray-600">
        <div class="text-6xl font-semibold text-gray-600">
          {{ safety.score.value }}
        </div>
        <div class="font-semibold mt-2">
          {{ safety.score.title }}
        </div>
        <div class="mt-2">
          {{ safety.score.description }}
        </div>
      </div>
    </div>
  </div>
  <div class="col-span-3" *ngIf="safety.violations.length > 0">
    <mat-accordion>
      <mat-expansion-panel *ngFor="let vio of safety.violations; trackBy: 'id' | trackByKey">
        <mat-expansion-panel-header>
          <div class="flex flex-row w-full">
            <div class="mr-3">{{ vio.shiftStartAt | standardDateOnly }}</div>
            <div [class.text-red-500]="vio.violations.length > 0">{{ vio.violations.length }} Violations</div>
          </div>
        </mat-expansion-panel-header>
        <div class="grid grid-cols-3 gap-2">
          <div>
            <div class="flex flex-col">
              <div class="flex flex-col">
                <div class="font-semibold">Time</div>
                <div class="text-gray-600">
                  {{ vio.shiftStartAt | standardDate }} - {{ vio.shiftEndAt | standardDate }}
                </div>
              </div>
              <div class="flex flex-col mt-2">
                <div class="font-semibold">Safety Violations</div>
                <div class="text-gray-600">{{ vio.violations.length }}</div>
              </div>
            </div>
          </div>
          <div class="col-span-2">
            <div
              class="flex flex-col py-2 border-b border-gray-400 last:border-0"
              *ngFor="let v of vio.violations; trackBy: 'id' | trackByKey"
            >
              <div class="flex flex-row justify-between">
                <div>
                  <span class="font-semibold">{{ v.type | safetyType }}</span>
                  {{ v.name }}
                </div>
                <div class="font-semibold">-{{ v.scores }}</div>
              </div>
              <div class="flex flex-row text-gray-600">
                <div>
                  {{ v.startAt | standardTime }}
                </div>
                <div class="mx-1">&bull;</div>
                <div>Expiry {{ v.expiredAt | standardDateOnly }}</div>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
